import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login.vue'
import Locations from './views/LocationListings.vue'
import Location from './views/Location.vue'
import Rydes from './views/Rydes.vue'
import Dashboard from './views/Dashboard.vue'
import Home from './views/Home.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }, 
    {
      path: '/locations', 
      name:'locations', 
      component: Locations, 
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/origin/:origin/dest/:dest',
      name: 'Rydes',
      component: Rydes, 
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard', 
      component: Dashboard, 
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/event/:id', 
      name: 'Event Details',
      component: () => import('./views/EventDetails.vue')
    }, 
    {
      path: '/event',
      name: 'Event', 
      component: () => import('./views/Event.vue'), 
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/location/:id', 
      name: 'location', 
      component: Location, 
      meta: {
        requiresAuth: true
      }
    },
  ]
})
